// extracted by mini-css-extract-plugin
export default {"containerGifs":"Gifs_containerGifs__9CkeV","sinBusqueda":"Gifs_sinBusqueda__3C4yz"};